import React, { Component } from 'react';
import { StickyContainer } from 'react-sticky';
import UnifiedNav from '../../common/header/UnificationNav/UnificationNav';
import MobileLandingHeader from './MobileLandingHeader';
import MobileLandingSection from './MobileLandingSection';
import { detectIOS } from '../../../util/detectBrowser';

import '../../../stylesheets/pages/MobileLandingPage.less';


// this landing page will be tested on optimizely
// optimizely will direct a percentage of mobile traffic to this page

class MobileLandingPage extends Component {
  // hack becuz in weddings, body has a margin bottom of 528px which is not necessary on this page
  // becuz we're not showing the footer;
  componentDidMount() {
    document.getElementsByTagName('body')[0].className = 'body__no-margin';
  }

  onIOS() {
    const onIOS = detectIOS();
    if (onIOS) {
      return true;
    }
    return false;
  }

  // this mobile app landing page is specific to IOS users becuz it calls out the IOS mobile app in the app store;

  renderMobileAppLandingPage() {
    return (
      <div>
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-present.svg"
          startText="Add Your"
          underline="First"
          underlineType="neg-2"
          endText="Gift"
          cta="start now"
          ctaLink="/registry/checklist"
        />
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-piggy-bank.svg"
          imgClassName="margin-top-10"
          startText="Fund Your"
          underline="Dream"
          endText="Trip/House/Puppy"
          underlineType="neg-2"
          cta="start a cash fund"
          ctaLink="/shop/honeymoon-cash-funds"
        />
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-iphone-app.svg"
          imgClassName="margin-top-10"
          className="mobile__iphone-app"
          startText="It's Even"
          underline="Easier"
          endText="On Our App"
          cta="download the app"
          ctaLink="https://itunes.apple.com/us/app/zola-registry/id852691916?mt=8"
          newTab="true"
        />
      </div>
    );
  }

  // if a user is NOT on IOS, show the default landing page (that has no references to a mobile app);
  renderLandingPage() {
    return (
      <div>
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-present.svg"
          startText="Add Your"
          underline="First"
          underlineType="neg-2"
          endText="Gift"
          cta="start now"
          ctaLink="/registry/checklist"
        />
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-piggy-bank.svg"
          imgClassName="margin-top-10"
          startText="Fund Your"
          underline="Dream"
          endText="Trip/House/Puppy"
          underlineType="neg-2"
          cta="start a cash fund"
          ctaLink="/shop/honeymoon-cash-funds"
        />
        <MobileLandingSection
          img="/images/doodles/mobile/doodle-hearts.svg"
          imgClassName="margin-top-20"
          startText="Browse Zola's"
          underline="Best Sellers"
          underlineType="neg-1"
          cta="see best sellers"
          ctaLink="/shop/collection/top-registry-gifts-this-week"
        />
      </div>
    );
  }

  render() {
    const onIOS = this.onIOS();
    return (
      <div>
        <StickyContainer>
          <UnifiedNav />
          <div className="mobile-landing-page__container">
            <MobileLandingHeader
              subTitle="Welcome to your Zola registry!"
              title="We'll help you get started."
            />
            {
              onIOS ?
              this.renderMobileAppLandingPage() :
              this.renderLandingPage()
            }
            <a href="/registry/dashboard">
              <div className="mobile-landing-page__footer">
                Skip, I want to explore ›
              </div>
            </a>
          </div>
        </StickyContainer>
      </div>
    );
  }
}


export default MobileLandingPage;



/** WEBPACK FOOTER **
 ** ./src/components/onboard/MobileLanding/MobileLandingPage.jsx
 **/